import { useEffect, useState } from "react";
import { nanoid } from "nanoid";
import Comment from "./Comment";
import NewComment from "./NewComment";
import data from "../data.json";
import { useChecklistContext } from "../../../context/checklistContext";

function Comments({ currentUser }) {
    const { IDCheck } = useChecklistContext();
    const [activeComment, setActiveComment] = useState(null);
    const [backendComments, setBackendComments] = useState([]);
    const [loading, setLoading] = useState(true);
    const allData = data;

    useEffect(() => {
        setLoading(true);
        setBackendComments([]);

        const comentarios = buscaComentarios(IDCheck);
        setBackendComments(comentarios);
        setLoading(false);
    }, [IDCheck]);

    const buscaComentarios = (IDCheck) => {
        const comentarios = allData.consideracoes.filter(
            (item) => item.IDCheck === IDCheck
        );
        return comentarios.length > 0 ? comentarios[0].comments : [];
    };

    const createComment = async (text) => ({
        content: text,
        createdAt: "Recém Criado",
        id: nanoid(),
        replies: [],
        user: currentUser,
    });

    const addComment = (text) => {
        createComment(text).then((comment) => {
            setBackendComments((prevComments) => [...prevComments, comment]);
        });
    };

    const deleteComment = (commentId) => {
        setBackendComments((prevComments) =>
            prevComments.filter((comment) => comment.id !== commentId)
        );
    };

    const updateComment = (text, commentId) => {
        const updatedComments = backendComments.map((comment) =>
            comment.id === commentId ? { ...comment, content: text } : comment
        );
        setBackendComments(updatedComments);
        setActiveComment(null);
    };

    return (
        <>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", fontSize: 18, fontWeight: 500 }}>
                <p>Comentários do Check {IDCheck}</p>
            </div>
            <main>
                {loading ? (
                    <p>Carregando comentários...</p>
                ) : backendComments.length > 0 ? (
                    backendComments.map((comment) => (
                        <Comment
                            key={comment.id}
                            currentUser={currentUser}
                            replies={comment.replies}
                            activeComment={activeComment}
                            setActiveComment={setActiveComment}
                            deleteComment={deleteComment}
                            addComment={addComment}
                            updateComment={updateComment}
                            {...comment}
                        />
                    ))
                ) : null}
                <NewComment
                    currentUser={currentUser}
                    handleSubmit={addComment}
                    initialText=""
                    buttonText="Enviar"
                />
            </main>
        </>
    );
}

export default Comments;
